import { strLang } from "../functions/strLang";

export const langGroup = [
  { code: "esp", name: "Español" },
  { code: "ing", name: "English" },
  { code: "ch", name: "繁體字" },
  { code: "chs", name: "简体字" },
];

export const labelsList = [
  "avatar",
  "initName",
  "initCode",
  "initPassword",
  "accept",
  "conditionsUse",
  "initEnter",
  "startLogin",
  "badCredentials",
  "netWorkError",
  "pleaseSelect",
  "conditionsLeyend",
  "accountInative",
  "accessRestricted",
];

export const msgType = {
  warning: { type: "warning" },
  loading: { type: "loading" },
  error: {
    type: "error",
    label: strLang("netWorkError"),
  },
};
